// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import PlayArrow20 from './PlayArrow20.tsx';
import PlayArrow20Filled from './PlayArrow20Filled.tsx';
import PlayArrow20CircleFilled from './PlayArrow20CircleFilled.tsx';
import PlayArrow24 from './PlayArrow24.tsx';
import PlayArrow24Filled from './PlayArrow24Filled.tsx';
import PlayArrow24CircleFilled from './PlayArrow24CircleFilled.tsx';
import PlayArrow36CircleFilled from './PlayArrow36CircleFilled.tsx';
import PlayArrow40 from './PlayArrow40.tsx';
import PlayArrow40Filled from './PlayArrow40Filled.tsx';
import PlayArrow48 from './PlayArrow48.tsx';
import PlayArrow48Filled from './PlayArrow48Filled.tsx';
import PlayArrow48CircleFilled from './PlayArrow48CircleFilled.tsx';

type PlayArrowProps = {
    variation:
        | '20'
        | '20Filled'
        | '20CircleFilled'
        | '24'
        | '24Filled'
        | '24CircleFilled'
        | '36CircleFilled'
        | '40'
        | '40Filled'
        | '48'
        | '48Filled'
        | '48CircleFilled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    PlayArrow20,
    PlayArrow20Filled,
    PlayArrow20CircleFilled,
    PlayArrow24,
    PlayArrow24Filled,
    PlayArrow24CircleFilled,
    PlayArrow36CircleFilled,
    PlayArrow40,
    PlayArrow40Filled,
    PlayArrow48,
    PlayArrow48Filled,
    PlayArrow48CircleFilled,
};

const PlayArrow: FC<PlayArrowProps> = ({ variation, ...props }) => {
    const variationKey = `PlayArrow${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"PlayArrow" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default PlayArrow;
